<template>
  <div
    class="sidenav-inner"
    :class="{ 'py-1': orientation !== 'horizontal' }"
    v-if="
      currentUser != '' &&
      ['developer', 'administrator'].includes(currentUser.role[0])
    "
  >
    <sidenav-router-link
      icon="fad fa-tv-alt"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
      to="/app"
      :exact="true"
      >Dashboard</sidenav-router-link
    >

    <sidenav-menu
      icon="fad fa-viruses"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <template slot="link-text">Data Merkuri</template>
      <sidenav-router-link to="/app/merkuri/alkes" :exact="true"
        >Alkes</sidenav-router-link
      >
      <sidenav-router-link to="/app/merkuri/pesk" :exact="true"
        >Pesk</sidenav-router-link
      >
    </sidenav-menu>

    <sidenav-menu
      icon="fad fa-truck-loading"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <template slot="link-text">Shipping Interim</template>
      <sidenav-router-link to="/app/shipping/pesk/approval" :exact="true"
        >PESK</sidenav-router-link
      >
      <sidenav-router-link to="/app/shipping/alkes/approval" :exact="true"
        >ALKES</sidenav-router-link
      >
    </sidenav-menu>

    <sidenav-menu
      icon="fad fa-box-check"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <template slot="link-text">Shipping Final</template>
      <sidenav-router-link to="/app/shipping/pesk/final" :exact="true"
        >PESK</sidenav-router-link
      >
      <sidenav-router-link to="/app/shipping/alkes/final" :exact="true"
        >ALKES</sidenav-router-link
      >
    </sidenav-menu>

    <!-- <sidenav-menu icon="fad fa-warehouse" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
      
      <template slot="link-text">WMS</template>

        <sidenav-menu>
          <template slot="link-text">Receiving and Putaway</template>
     
                <sidenav-menu>
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/receiving/alkes/final/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/final/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/final/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>

                </sidenav-menu>
                <sidenav-router-link to="/app/wms/pesk/final/receiving" :exact="true">Pesk</sidenav-router-link> 
              
        </sidenav-menu>
      
      

        <sidenav-menu>
            <template slot="link-text">Pengemasan Ulang</template>
            

              <sidenav-menu >
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/final/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/final/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/final/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>
              </sidenav-menu>

            <sidenav-router-link to="/app/wms/pengemasan/ulang/final" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu>

     
     
        <sidenav-router-link to="/app/wms/stock/final" :exact="true">Stock take (Stock Opname)</sidenav-router-link>
     

        <sidenav-menu>
          <template slot="link-text">Reporting</template>
            <sidenav-router-link to="/app/wms/reporting/final/alkes" :exact="true">Alkes</sidenav-router-link>
            <sidenav-router-link to="/app/wms/reporting/final/pesk" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu>

     
    </sidenav-menu> -->

    <!-- SUB WMS -->
    <sidenav-menu
      icon="fad fa-warehouse"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <template slot="link-text">SUB WMS</template>

      <sidenav-router-link to="/app/wms/stock/provinsi/storage" :exact="true"
        >Stock take (Stock Opname)</sidenav-router-link
      >

      <sidenav-menu>
        <template slot="link-text">Reporting</template>
        <sidenav-router-link
          to="/app/wms/reporting/provinsi/alkes/storage"
          :exact="true"
          >Alkes</sidenav-router-link
        >
        <sidenav-router-link
          to="/app/wms/reporting/provinsi/pesk/storage"
          :exact="true"
          >Pesk</sidenav-router-link
        >
      </sidenav-menu>

      <!-- <sidenav-router-link to="/app/wms/stock/final/agent" :exact="true">Stock take (Stock Opname)</sidenav-router-link>
        
        <sidenav-menu>
          <template slot="link-text">Reporting</template>
            <sidenav-router-link to="/app/wms/reporting/final/alkes/agent" :exact="true">Alkes</sidenav-router-link>
            <sidenav-router-link to="/app/wms/reporting/final/pesk/agent" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu> -->
    </sidenav-menu>

    <!-- END -->

    <sidenav-menu
      icon="fad fa-layer-group"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <template slot="link-text">Master Data</template>
      <sidenav-router-link
        v-if="currentUser.role[0] == 'developer'"
        to="/app/masterdata"
        :exact="true"
        >Data Master</sidenav-router-link
      >
      <sidenav-router-link to="/app/masterdata/user-management" :exact="true"
        >User Management</sidenav-router-link
      >
      <sidenav-router-link
        v-if="currentUser.role[0] == 'developer'"
        to="/app/borangmasteralkes"
        :exact="true"
        >Borang Master Alkes</sidenav-router-link
      >
      <sidenav-router-link to="/app/masterwadah" :exact="true"
        >Borang Master Wadah</sidenav-router-link
      >
      <sidenav-router-link to="/app/masterwms" :exact="true"
        >Borang Master WMS</sidenav-router-link
      >
       <sidenav-router-link to="/app/masterdata/instansi-management" :exact="true"
        >Instansi Management</sidenav-router-link
      >
      <sidenav-router-link to="/app/masterdata/pelapor-management" :exact="true"
        >Data Pelapor</sidenav-router-link
      >
      <!-- <sidenav-router-link to="/app/borangmasteralkes" :exact="true"
        >Borang Master Alkes</sidenav-router-link
      > -->
      
    </sidenav-menu>

    <sidenav-menu
      icon="fad fa-layer-group"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <template slot="link-text">CMS</template>

      <sidenav-router-link to="/app/tentang/sipamer" :exact="true"
        >Tentang Sipamer</sidenav-router-link
      >

      <sidenav-router-link to="/app/fitur" :exact="true"
        >Fitur</sidenav-router-link
      >

      <!-- <sidenav-router-link to="/app/banner" :exact="true"
        >Banner</sidenav-router-link
      > -->

      <sidenav-router-link to="/app/wms" :exact="true">WMS</sidenav-router-link>

      <sidenav-router-link to="/app/faq" :exact="true">FAQ</sidenav-router-link>

      <sidenav-router-link to="/app/inquiries" :exact="true"
        >Inquiries</sidenav-router-link
      >

      <sidenav-router-link to="/app/web-config" :exact="true"
        >Web Config</sidenav-router-link
      >
    </sidenav-menu>

    <li
      class="sidenav-item"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <a href="/app/laporan" class="sidenav-link"
        ><i class="fad fa-archive"></i>
        <div style="padding-left: 15px">Laporan</div>
      </a>
    </li>

    <li
      class="sidenav-item"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <a href="/app/export" class="sidenav-link"
        ><i class="fad fa-file-export"></i>
        <div style="padding-left: 15px">Export Data</div>
      </a>
    </li>

    <li
      class="sidenav-item"
      style="
        --fa-secondary-opacity: 1;
        --fa-primary-color: var(--c-cyan);
        --fa-secondary-color: var(--c-purple);
      "
    >
      <a target="_blank" href="/dms" class="sidenav-link"
        ><i class="fad fa-tv-alt"></i>
        <div style="padding-left: 15px">Dashboard Monitoring Sistem</div>
      </a>
    </li>
  </div>
</template>
<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider,
} from "@/vendor/libs/sidenav";
export default {
  data: () => ({}),
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider,
  },
  props: {
    orientation: {
      type: String,
      default: "vertical",
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },

    isMenuOpen(url) {
      return (
        this.$route.path.indexOf(url) === 0 && this.orientation !== "horizontal"
      );
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },
  },
};
</script>
